import styled from 'styled-components';

import { ContentWrapper } from 'components/utilities/pageStyles';

export const ContentWrapperStyle = styled(ContentWrapper)`
  padding-top: 0px;
  padding-bottom: 0px;
  overflow-x: hidden;
`;

export const NarrowContent = styled.div`
  width: ${({ customWidth }) => customWidth};
  max-width: 100%;
  margin: 0 auto;

  ${({ forceDarkModeContent }) =>
    forceDarkModeContent ? `background: none; ` : ''}
`;
